'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var Key = require('interface-datastore').Key;

var _require = require('p-queue'),
    Queue = _require.default;

var _get = require('just-safe-get');

var _set = require('just-safe-set');

var _has = require('lodash.has');

var errcode = require('err-code');

var errors = require('./errors');

var configKey = new Key('config');

module.exports = function (store) {
  var setQueue = new Queue({
    concurrency: 1
  });
  var configStore = {
    /**
     * Get the current configuration from the repo.
     *
     * @param {Object} options - options
     * @param {AbortSignal} options.signal - abort this config read
     * @returns {Promise<Object>}
     */
    getAll: function getAll() {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var options;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                return _context.abrupt("return", configStore.get(undefined, options));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * Get the value for the passed configuration key from the repo.
     *
     * @param {String} key - the config key to get
     * @param {Object} options - options
     * @param {AbortSignal} options.signal - abort this config read
     * @returns {Promise<Object>}
     */
    get: function get(key) {
      var _arguments2 = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var options, encodedValue, config, value;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {};

                if (!key) {
                  key = undefined;
                }

                _context2.next = 4;
                return store.get(configKey);

              case 4:
                encodedValue = _context2.sent;

                if (!(options.signal && options.signal.aborted)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return");

              case 7:
                config = JSON.parse(encodedValue.toString());

                if (!(key !== undefined && !_has(config, key))) {
                  _context2.next = 10;
                  break;
                }

                throw new errors.NotFoundError("Key ".concat(key, " does not exist in config"));

              case 10:
                value = key !== undefined ? _get(config, key) : config;
                return _context2.abrupt("return", value);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * Set the current configuration for this repo.
     *
     * @param {String} key - the config key to be written
     * @param {Object} value - the config value to be written
     * @param {Object} options - options
     * @param {AbortSignal} options.signal - abort this config write
     * @returns {void}
     */
    set: function set(key, value) {
      var _arguments3 = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var options;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _arguments3.length > 2 && _arguments3[2] !== undefined ? _arguments3[2] : {};

                if (!(_arguments3.length === 1)) {
                  _context3.next = 6;
                  break;
                }

                value = key;
                key = undefined;
                _context3.next = 8;
                break;

              case 6:
                if (!(!key || typeof key !== 'string')) {
                  _context3.next = 8;
                  break;
                }

                throw errcode(new Error('Invalid key type: ' + typeof key), 'ERR_INVALID_KEY');

              case 8:
                if (!(value === undefined || Buffer.isBuffer(value))) {
                  _context3.next = 10;
                  break;
                }

                throw errcode(new Error('Invalid value type: ' + typeof value), 'ERR_INVALID_VALUE');

              case 10:
                return _context3.abrupt("return", setQueue.add(function () {
                  return _maybeDoSet({
                    key: key,
                    value: value
                  }, options.signal);
                }));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    /**
     * Set the current configuration for this repo.
     *
     * @param {Object} value - the config value to be written
     * @param {Object} options - options
     * @param {AbortSignal} options.signal - abort this config write
     * @returns {void}
     */
    replace: function replace(value) {
      var _arguments4 = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var options;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : {};

                if (!(!value || Buffer.isBuffer(value))) {
                  _context4.next = 3;
                  break;
                }

                throw errcode(new Error('Invalid value type: ' + typeof value), 'ERR_INVALID_VALUE');

              case 3:
                return _context4.abrupt("return", setQueue.add(function () {
                  return _maybeDoSet({
                    key: undefined,
                    value: value
                  }, options.signal);
                }));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },

    /**
     * Check if a config file exists.
     *
     * @returns {Promise<bool>}
     */
    exists: function exists() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", store.has(configKey));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  };
  return configStore;

  function _maybeDoSet(_x, _x2) {
    return _maybeDoSet2.apply(this, arguments);
  }

  function _maybeDoSet2() {
    _maybeDoSet2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(m, signal) {
      var key, value, config;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(signal && signal.aborted)) {
                _context6.next = 2;
                break;
              }

              return _context6.abrupt("return");

            case 2:
              key = m.key;
              value = m.value;

              if (!key) {
                _context6.next = 10;
                break;
              }

              _context6.next = 7;
              return configStore.get();

            case 7:
              config = _context6.sent;

              _set(config, key, value);

              return _context6.abrupt("return", _saveAll(config));

            case 10:
              return _context6.abrupt("return", _saveAll(value));

            case 11:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return _maybeDoSet2.apply(this, arguments);
  }

  function _saveAll(config) {
    var buf = Buffer.from(JSON.stringify(config, null, 2));
    return store.put(configKey, buf);
  }
};